import { SignInPage, useOperator } from '@features/auth';
import { atelierHubUrl } from '@lib/env';
import { Navigate } from 'react-router';

/**
 * The one route outside the dashboard gate — it has to be reachable precisely
 * when there is no session.
 *
 * It still checks: arriving here *with* a valid session (a stale tab, a
 * bookmark) means there is nothing to do but go back in. The check is free —
 * `useOperator` shares its query key with the shell, so this reads the cache
 * rather than issuing a second `/auth/me`.
 */
export function SignInRoute() {
    const { data: operator } = useOperator();

    if (operator) return <Navigate to="/overview" replace />;

    return <SignInPage hubUrl={atelierHubUrl()} />;
}
